import MercedesControllers from "../../../../pages-v1/MercedesControllers";

export const Page = MercedesControllers;
